<template>
  <div class="compliance">
    <div class="container pb-4" style="max-width: 768px; margin: 0 auto">
      <div class="row pt-md-4 pb-md-5">
        <div class="col-12">
          <div class="compliance__title">Employee compliance</div>
          <div class="compliance__desc">
            General overview of of employees daily compliance. Only visible to
            admins.
          </div>
        </div>
      </div>

      <employee-compliance-all />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.compliance {
  margin-top: 65px;

  @media (max-width: 768px) {
    margin-top: 18px;
  }

  &__title {
    color: #303030;
    font-family: Lato;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 53.2px;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 24px;
      text-align: left;
    }
  }

  &__desc {
    color: #606064;
    font-family: "Open Sans";
    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 14px;
      text-align: left;
      line-height: 20px;
      margin-bottom: 12px;
    }
  }
}
</style>
